import React, { useEffect } from "react";
import { CloseButton, Toast, ToastContainer } from "react-bootstrap";

interface ICustomToastProps {
  isShow: boolean;
  handleClose: () => void;
  message: string;
  containerClassName?: string;
}
export default function CustomToast({
  isShow,
  handleClose,
  message,
  containerClassName,
}: ICustomToastProps) {
  useEffect(() => {
    if (isShow) {
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isShow]);

  return (
    <ToastContainer
      position="bottom-center"
      className={`${containerClassName ? containerClassName : "p-5"} position-fixed`}
    >
      <Toast show={isShow} bg="dark">
        <Toast.Body className="text-white d-flex align-items-center justify-content-between p-3">
          <span>{message}</span>
          <CloseButton variant="white" onClick={handleClose} />
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}
